import React, { useCallback, useState } from 'react';
import { Button, Divider, Flex } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Dropdown } from '../../../../../shared/ui/Dropdown';
import { useAdminUserMutations } from '../hooks/useAdminUserMutations';

export const TableAction = ({ user }) => {
    const [open, setOpen] = useState(false);

    const {
        unblockUserById,
        blockUserById,
        sendNewPassword,
        handleViewUser,
        handleChangeCommission,
        sendNewPasswordState,
        unblockUserState,
        blockUserState,
        getAccessTokenState,
    } = useAdminUserMutations();

    const actions = [
        {
            label: 'Изменить процент',
            onClick: () => {
                handleChangeCommission(user);
                setOpen(false);
            },
            loading: false,
        },
        {
            label: 'Выслать пароль',
            onClick: () => {
                sendNewPassword(user.id);
                setOpen(false);
            },
            loading: sendNewPasswordState.isLoading,
        },
        {
            isDivider: true,
        },
        user?.is_blocked
            ? {
                  label: 'Разблокировать пользователя',
                  onClick: () => {
                      unblockUserById(user.id);
                      setOpen(false);
                  },
                  loading: unblockUserState.isLoading,
              }
            : {
                  label: 'Заблокировать пользователя',
                  onClick: () => {
                      blockUserById(user.id);
                      setOpen(false);
                  },
                  loading: blockUserState.isLoading,
              },
        {
            label: 'Авторизоваться',
            onClick: () => {
                handleViewUser(user);
                setOpen(false);
            },
            loading: getAccessTokenState.isLoading,
        },
    ];

    const dropdownContent = useCallback(
        () => (
            <Flex vertical onMouseLeave={() => setOpen(false)}>
                {actions.map((action, idx) =>
                    action.isDivider ? (
                        <Divider key={`divider-${idx}`} style={{ margin: 0 }} />
                    ) : (
                        <Button
                            key={action.label}
                            loading={action.loading}
                            type='text'
                            onClick={action.onClick}
                        >
                            {action.label}
                        </Button>
                    )
                )}
            </Flex>
        ),
        [actions]
    );

    return (
        <StyledDropdown
            open={open}
            onOpenChange={setOpen}
            dropdownContent={dropdownContent}
        >
            <Button type='default' onClick={() => setOpen(v => !v)}>
                Действие <DownOutlined />
            </Button>
        </StyledDropdown>
    );
};

const StyledDropdown = styled(Dropdown)`
    margin-left: auto;
    cursor: pointer;

    button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        border: none;
        box-shadow: none;
        padding: 0;

        span:nth-child(1) {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
